const ja = {
  action: {
    save: '保存',
    close: '閉じる',
    cancel: 'キャンセル',
    submit: '送信',
  },
} as const;

export default ja;
